import { getPercentageDiff } from '@workalizer/shared/utils';
var buildDocument = function (documentId, documentTitle, commentsResolved, suggestionsResolved, prevCommentsResolved, prevSuggestionsResolved) { return ({
    documentId: documentId,
    documentTitle: documentTitle,
    commentsResolved: commentsResolved,
    suggestionsResolved: suggestionsResolved,
    totalResolved: commentsResolved + suggestionsResolved,
    previousPeriod: {
        commentsResolved: getPercentageDiff(prevCommentsResolved, commentsResolved),
        suggestionsResolved: getPercentageDiff(prevSuggestionsResolved, suggestionsResolved)
    }
}); };
export var userActivityOnResolving = function () {
    return {
        documents: [
            buildDocument(1, 'Project Requirements Document', 15, 8, 10, 6),
            buildDocument(2, 'API Documentation', 12, 5, 8, 7),
            buildDocument(3, 'User Interface Design', 8, 12, 12, 9),
            buildDocument(4, 'Database Schema', 6, 3, 4, 5),
            buildDocument(5, 'Testing Strategy', 4, 7, 6, 4)
        ]
    };
};
